import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { handleDownloadPdf } from "../shared/functions";

const Header = () => {
  const { t, i18n } = useTranslation();
  const languageRef = React.useRef(null);
  const burgerRef = React.useRef(null);
  const smallMenuLang = React.useRef(null);
  const prevScroll = React.useRef(0);
  const [selectedLanguage, setSelectedLanguage] = React.useState(i18n.language);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isBurgerOpen, setIsBurgerOpen] = React.useState(false);

  const isRussianDomain = window.location.hostname === "tramptec.ru";

  const languages = [
    { id: 1, name: "ru" },
    { id: 2, name: "en" },
    { id: 3, name: "tr" },
    { id: 4, name: "de" },
    { id: 5, name: "es" },
    { id: 6, name: "fr" },
  ];

  const handleLanguage = (el) => {
    setSelectedLanguage(el.name);
    i18n.changeLanguage(el.name);
  };

  const handleCleaner = () => {
    window.scrollTo(0, 0);
  };

  const handleCloseLang = (e) => {
    if (languageRef.current && !languageRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  const handleCloseSmallLang = (e) => {
    if (smallMenuLang.current && !smallMenuLang.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    if (isRussianDomain && i18n.language !== "ru") {
      i18n.changeLanguage("ru");
      setSelectedLanguage("ru");
    }
  }, []);

  React.useEffect(() => {
    const handleHeader = () => {
      const currentScroll = window.scrollY;
      const header = document.querySelector("header");

      if (currentScroll > 0) {
        if (prevScroll.current > currentScroll) {
          header.classList.add("sticky");
        } else {
          header.classList.remove("sticky");
        }
      } else if (currentScroll < 100) {
        header.classList.remove("sticky");
      }

      prevScroll.current = currentScroll;
    };

    window.addEventListener("scroll", handleHeader);
    return () => {
      window.removeEventListener("scroll", handleHeader);
      window.removeEventListener("scroll", handleCloseSmallLang);
    };
  }, []);

  return (
    <header>
      <div className="header--logo" onClick={handleCleaner}>
        <Link to="/" />
      </div>
      <nav>
        <ul className="nav--items">
          <li>
            <Link to="/catalog">{t("header.catalog")}</Link>
          </li>
          <li>
            <Link to="/contacts">{t("header.contacts")}</Link>
          </li>
          <li className="download" onClick={handleDownloadPdf}>
            {t("header.download")}
          </li>
          {!isRussianDomain && (
            <li>
              <div
                ref={languageRef}
                className="language"
                onClick={() => setIsOpen(!isOpen)}
              >
                <div className="language--select">
                  <p>{selectedLanguage}</p>
                  <div
                    className={
                      isOpen
                        ? "language--select__arrow-active"
                        : "language--select__arrow"
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M0.35 4.257c0-.354.14-.694.406-.966.546-.53 1.442-.53 1.988 0L7 7.412l4.256-4.134c.546-.53 1.442-.53 1.988 0 .546.53.546 1.4 0 1.931L7.994 10.309A1.35 1.35 0 0 1 7 10.703a1.35 1.35 0 0 1-.994-.395L0.756 5.222A1.35 1.35 0 0 1 0.35 4.257Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </div>
                {isOpen && (
                  <div className="language--items">
                    {languages.map((el) => (
                      <div
                        className="language--item"
                        onClick={() => handleLanguage(el)}
                        key={el.id}
                      >
                        {selectedLanguage === el.name ? null : (
                          <span>{el.name}</span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </li>
          )}
        </ul>
        <div ref={burgerRef} className="burger--menu">
          {!isRussianDomain && (
            <div
              ref={smallMenuLang}
              className="burger-language"
              onClick={() => setIsOpen(!isOpen)}
            >
              <div className="language--select">
                <p>{selectedLanguage}</p>
                <div
                  className={
                    isOpen
                      ? "language--select__arrow-active"
                      : "language--select__arrow"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M0.35 4.257c0-.354.14-.694.406-.966.546-.53 1.442-.53 1.988 0L7 7.412l4.256-4.134c.546-.53 1.442-.53 1.988 0 .546.53.546 1.4 0 1.931L7.994 10.309A1.35 1.35 0 0 1 7 10.703a1.35 1.35 0 0 1-.994-.395L0.756 5.222A1.35 1.35 0 0 1 0.35 4.257Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
              {isOpen && (
                <div className="burger-language_items">
                  {languages.map((el) => (
                    <div
                      className={
                        selectedLanguage === el.name
                          ? "selected burger-language--item"
                          : "burger-language--item"
                      }
                      onClick={() => handleLanguage(el)}
                      key={el.id}
                    >
                      {selectedLanguage === el.name ? null : (
                        <span>{el.name}</span>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          <div className="burger--button" onClick={() => setIsBurgerOpen(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="20"
              viewBox="0 0 2 10"
              fill="none"
            >
              <path d="M1 0V10" stroke="black" />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="20"
              viewBox="0 0 2 10"
              fill="none"
            >
              <path d="M1 0V10" stroke="black" />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="20"
              viewBox="0 0 2 10"
              fill="none"
            >
              <path d="M1 0V10" stroke="black" />
            </svg>
          </div>
          {isBurgerOpen && (
            <div className="burger--container">
              <div
                className="exit--container"
                onClick={() => setIsBurgerOpen(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 10 10"
                  fill="none"
                >
                  <path d="M1 1L9 9" stroke="black" strokeLinecap="round" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 10 10"
                  fill="none"
                >
                  <path d="M9 1L1 9" stroke="black" strokeLinecap="round" />
                </svg>
              </div>
              <ul className="burger--items">
                <li>
                  <Link to="/catalog" onClick={() => setIsBurgerOpen(false)}>
                    {t("header.catalog")}
                  </Link>
                </li>
                <li>
                  <Link to="/contacts" onClick={() => setIsBurgerOpen(false)}>
                    {t("header.contacts")}
                  </Link>
                </li>
                <li onClick={handleDownloadPdf} className="download">
                  {t("header.download")}
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
